<a
    (click)="back()"
    (keydown.enter)="back()"
    (keydown.space)="back()"
    class="btn btn-secondary order-md-2 order-1 w-100 w-md-auto"
    role="button"
    accesskey="z"
    tabindex="0"
    [innerHTML]="translatedText"
>
</a>
